// side effect: fetch llmf data
import {fetchRelux1, fetchRelux2, clearRelux1, clearRelux2} from '../slices/productDataSlice';
import {
	selectFinalized,
	selectLightengine1Code,
	selectLightengine2Code, selectProductCodes,
	selectProductData,
	selectSpcIsSatisfied,
	selectSpcSession,
	selectVariantCodeTypes
} from '../selectors';
import {mapReluxDownloads} from '../util/mapReluxDownloads';
import {saveRelux} from '../slices/configurationSlice';

export const reluxMiddleware = store => next => action => {
    const result = next(action);
	// console.log('reluxMiddleware', selectSpcIsSatisfied(store.getState()), action.type);

	// skip when feature is off
	//if (store.getState().status.features.relux !== true) return result;
	if (selectSpcIsSatisfied(store.getState()) && action.type === 'configuration/store/fulfilled') {
		const spcSession = selectSpcSession(store.getState());
		const productData = selectProductData(store.getState());
		const finalized = selectFinalized(store.getState());
		const state = store.getState();

		if (spcSession !== null && productData !== null) {
			const codes =  selectProductCodes(state);
			const key = codes.find(v => v.name === 'REL')?.code;
			if (key !== '') {
				store.dispatch(fetchRelux1({
					url: state.status.apiUrl + '/relux?key=' + key
				}));
			} else {
				store.dispatch(clearRelux1());
			}
        }
    }

	if (action.type === 'productData/Relux1Loading/fulfilled') {
		//console.log('reluxMiddleware', mapReluxDownloads(action.payload.data));
		store.dispatch(saveRelux({relux: mapReluxDownloads(action.payload.data)}));
	}
    return result;
};
